interface Props {
  children: React.ReactNode
}
export const _Root = ({ children, ...rest }: Props) => (
  <div className='flex h-fit w-full flex-col gap-3' {...rest}>
    {children}
  </div>
)
